var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_2110_273781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666843 16.4933C-0.22228 14.95 -0.222281 13.05 0.666842 11.5067L5.35078 3.37639C6.24239 1.82875 7.89255 0.875 9.67865 0.875L19.0279 0.875C20.814 0.875 22.4642 1.82875 23.3558 3.37639L28.0397 11.5067C28.9289 13.05 28.9289 14.95 28.0397 16.4933L23.3558 24.6236C22.4642 26.1713 20.814 27.125 19.0279 27.125L9.67865 27.125C7.89255 27.125 6.24239 26.1713 5.35078 24.6236L0.666843 16.4933Z",
    fill: "#19191E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2110_273781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8562 10.2252C17.4332 10.4692 17.9668 10.7898 18.4508 11.1807V8.41754C18.4508 6.11972 16.5811 4.25002 14.2833 4.25002H14.2192C11.9234 4.25002 10.0537 6.11972 10.0537 8.41754V11.1807C10.5377 10.7898 11.0713 10.4693 11.6483 10.2252C11.8035 10.159 11.9627 10.099 12.122 10.0453V8.41754C12.122 7.25932 13.063 6.31827 14.2212 6.31827H14.2854C15.4436 6.31827 16.3846 7.25932 16.3846 8.41754V10.0473C16.5418 10.099 16.7011 10.159 16.8562 10.2252Z",
    fill: "#E9BE5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38965 16.3887C8.38965 19.6255 11.0143 22.2501 14.2511 22.2501C17.4879 22.2501 20.1125 19.6276 20.1125 16.3887C20.1125 14.7982 19.4775 13.3546 18.4496 12.2977C17.8705 11.7041 17.1673 11.2325 16.3814 10.9244C15.7216 10.6658 15.0019 10.5252 14.2511 10.5252C13.5003 10.5252 12.7806 10.6658 12.1208 10.9244C11.3349 11.2305 10.6317 11.702 10.0525 12.2977C9.02253 13.3546 8.38965 14.7982 8.38965 16.3887ZM12.7412 15.2057C12.7619 14.4052 13.4134 13.7537 14.2138 13.7351C15.0639 13.7144 15.7609 14.399 15.7609 15.2449C15.7609 15.3339 15.7526 15.4207 15.7381 15.5035C15.6636 15.9316 15.4093 16.2997 15.0535 16.5231C14.9066 16.6162 14.8322 16.7899 14.8695 16.9575L15.3183 19.0857C15.3452 19.2139 15.248 19.336 15.1156 19.336H13.3865C13.2542 19.336 13.1569 19.216 13.1839 19.0857L13.6326 16.9575C13.6678 16.7879 13.5954 16.6141 13.4486 16.5211C13.0929 16.2977 12.8385 15.9316 12.764 15.5014C12.7474 15.4063 12.7392 15.307 12.7412 15.2057Z",
    fill: "#E9BE5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_2110_273781",
    x: -2.37725,
    y: -1.50225,
    width: 33.4611,
    height: 31.0045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.18863
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2110_273781"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2110_273781",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.365731
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.182866
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2110_273781"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.10872
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2110_273781",
    result: "effect3_innerShadow_2110_273781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2110_273781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5.25098 4.25008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock2);
export default __webpack_public_path__ + "static/media/lock2.31bd9d58c1c21d0e542dc03c3a8f5d49.svg";
export { ForwardRef as ReactComponent };